var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.ProductDrag = new Class({
    Implements: [Options, Events],
    options: {
        draggable_product_types: [
            OCS.Constants.EMBEDDABLE_URL,
            OCS.Constants.EMBEDDABLE_STATIC_URL,
            OCS.Constants.EMBEDDABLE_IMAGE,
            OCS.Constants.EMBEDDABLE_TEXT,
            OCS.Constants.DYNAMIC_MAP,
            OCS.Constants.EMBEDDABLE_PRODUCT
        ],
    },
    bound_methods: {},
    initialize: function (ops) {
        this.setOptions(ops);
        this.bound_methods.on_element_dropped = this.on_element_dropped.bind(this);
        this.bound_methods.on_dragged_complete = this.on_dragged_complete.bind(this);
        this.init_draggable();
    },
    init_draggable: function () {
        this.options.draggable_product_types.each(function (prod_type) {
            $$('.product div[data-product_type="' + prod_type + '"]').each(function (drag) {
                var df = new OCS.WxBriefing.Classes.DragFunctionality(drag, {onComplete: this.bound_methods.on_dragged_complete, onDropped: this.bound_methods.on_element_dropped});
            }, this);
        }, this);
        return this;
    },
    init_droppable: function () {
        var df = new OCS.WxBriefing.Classes.DragFunctionality();
        df.init_droppable();
        return this;
    },
    destroy_droppable: function () {
        var df = new OCS.WxBriefing.Classes.DragFunctionality();
        df.destroy_droppable();
    },
    on_dragged_complete: function (element) {
        OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
    },
    on_element_dropped: function (element, droppable) {
        var state = {};
        var panel = droppable.getProperty('id').replace('drop_panel_', 'p');
        state[panel] = {};
        state[panel].entry_id = element.get('data-entry_id');
        OCS.WxBriefing.Functions.get_url_manager().update_url_state(state, 0);
    }

});
OCS.WxBriefing.Functions.get_product_drag = function (ops) {
    if (!OCS.WxBriefing.Live.ProductDrag) {
        OCS.WxBriefing.Live.ProductDrag = new OCS.WxBriefing.Classes.ProductDrag(ops);
    }
    return OCS.WxBriefing.Live.ProductDrag;
};
